import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ApproverService } from '../../../core/services/approver.service';
import { PopupMessageService } from '../../../shared/message/services/message.service';

@Component({
  selector: 'app-reject-modal',
  templateUrl: './reject-modal.component.html',
  styleUrls: ['./reject-modal.component.scss']
})
export class RejectModalComponent implements OnChanges {

  @Input() isOpen: boolean = false;
  @Input() data: any;
  @Output() close = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<void>();

  rejectComments = '';

  constructor(
    private approverService: ApproverService,
    private popupMessageService: PopupMessageService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isOpen'] && this.isOpen) {
      this.rejectComments = '';
    }
  }

  onClose() {
    this.close.emit();
  }

  onConfirm() {
    const req = '?userChallengeId=' + this.data.userChallengeId + '&fileId=' + this.data.fileId +
      '&status=REJECTED&comments=' + this.rejectComments;
    this.approverService.updateStatus(req).subscribe(() => {
      this.rejectComments = '';
      this.popupMessageService.showSuccess('Status updated successfully.', 'success');
      this.confirmed.emit();
    });
  }
}
